export default __webpack_public_path__ + "static/media/flag-10.1b70d708.gif";